import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { STORY_LINES, PAINS } from "@/lib/content";

export const Story = () => (
  <section data-testid="story-section" className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-40">
    <div className="grid gap-12 lg:grid-cols-12">
      <Reveal className="lg:col-span-4">
        <p className="eyebrow">From dropshipping fail</p>
        <p className="font-serif-i mt-3 text-3xl text-zinc-300">to the First Mover Method</p>
      </Reveal>
      <div className="lg:col-span-8">
        {STORY_LINES.map((line, i) => (
          <motion.p key={line} data-testid={`story-line-${i}`}
            initial={{ opacity: 0.12 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.6 }}
            transition={{ duration: 0.9, delay: 0.05 }}
            className={`font-display border-b border-line py-6 text-2xl font-medium leading-snug tracking-tight md:text-4xl ${i === 3 ? "text-white" : "text-zinc-200"}`}>
            <span className="mb-3 block font-sans text-xs tracking-widest text-zinc-500">0{i + 1}</span>
            {line}
          </motion.p>
        ))}
      </div>
    </div>
  </section>
);

export const Pains = () => (
  <section data-testid="pains-section" className="border-t border-line bg-[#080808]">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-36">
      <Reveal>
        <p className="eyebrow">If this sounds like you</p>
        <h2 className="font-display mt-5 max-w-3xl text-4xl font-medium leading-tight tracking-tight text-white md:text-6xl">
          It is not a motivation problem. <span className="font-serif-i text-zinc-400">It is a timing problem.</span>
        </h2>
      </Reveal>
      <div className="mt-20 grid gap-px bg-line md:grid-cols-3">
        {PAINS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1} className="h-full">
            <div data-testid={`pain-${i}`} className={`h-full bg-[#080808] p-8 md:p-10 md:pb-14`}>
              <span className="font-display text-6xl font-semibold text-[#1f1f1f]">0{i + 1}</span>
              <h3 className="font-display mt-6 text-xl font-medium leading-snug text-white md:text-2xl">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-zinc-400 md:text-base">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
